import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Generate from "@/pages/Generate";
import Verify from "@/pages/Verify";
import Login from "@/pages/Login";
import AgentDashboard from "@/pages/AgentDashboard";
import AgentNewCard from "@/pages/AgentNewCard";
import AgentSales from "@/pages/AgentSales";
import AgentCardSuccess from "@/pages/AgentCardSuccess";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminAgents from "@/pages/AdminAgents";
import AdminSales from "@/pages/AdminSales";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter basename={process.env.REACT_APP_BASENAME || "/"}>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/generate" element={<Generate />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/login" element={<Login />} />

            <Route
              path="/agent"
              element={
                <ProtectedRoute roles={["agent"]}>
                  <AgentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent/new"
              element={
                <ProtectedRoute roles={["agent"]}>
                  <AgentNewCard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent/sales"
              element={
                <ProtectedRoute roles={["agent"]}>
                  <AgentSales />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent/card-success"
              element={
                <ProtectedRoute roles={["agent"]}>
                  <AgentCardSuccess />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/agents"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminAgents />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/sales"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AdminSales />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
